module.exports = __webpack_public_path__ + "static/media/Collections-FnB-experiences-Mobile.8ec94a2d.webp";